import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

// Load components
import { gridDebug } from "./components/grid-debug.js";
import { Modal } from "./components/modal.js";
import { Accordion } from "./components/accordion.js";
import { Burger } from "./components/burger.js";
import { FloatLabel } from "./components/floating-label";
import { animateOnScroll } from "./components/animate-on-scroll.js";
import { horizontalScroll } from "./components/horizontal-scroll.js";
import Slider from "./components/sliders";

let bp_sm = window.matchMedia("(max-width: 768px)").matches;
let bp_md = window.matchMedia("(max-width: 1024px)").matches;
let bp_lg = window.matchMedia("(min-width: 1024px)").matches;

// Issue when submiting AJAX GF form -> Convert to vanilla if you dare
jQuery(document).bind("gform_post_render", function () {
	FloatLabel.init();
});

document.addEventListener("DOMContentLoaded", (e) => {
	// Load grid debug on dev environement
	if (themeVars.is_dev) gridDebug.init();

	// Initialize components
	Modal.init();
	Burger.init();
	FloatLabel.init();
	Accordion.init();
	animateOnScroll.init();

	if (window.matchMedia("(min-width: 768px)").matches) {
		horizontalScroll.init();
	}

	/**
	 * HEADER
	 */
	let header_main = document.querySelector(".header");

	if (typeof header_main != "undefined" && header_main != null) {
		const getHeaderH = () => {
			let header_height = document.querySelector(".header").offsetHeight;
			document.body.style.setProperty("--_header-h", `${header_height}px`);
		};

		const stickyHeader = () => {
			getHeaderH();
			if (!document.body.classList.contains("search")) {
				document.body.classList.toggle("header-is-stuck", window.scrollY >= 1);
			}
		};

		getHeaderH();
		stickyHeader();

		window.addEventListener("resize", () => {
			getHeaderH();
		});

		document.addEventListener("scroll", () => {
			stickyHeader();
			getHeaderH();
		});
	}

	/**
	 * Mobile Nav
	 */
	if (window.matchMedia("(max-width: 1024px)").matches) {
		let nav_has_children = document.querySelectorAll(".menu-item-has-children");
		nav_has_children.forEach((nav) => {
			const triggers = nav.querySelectorAll(".drop-nav-trigger, .nav-list__link[href='#']");
			triggers.forEach((trigger) => {
				trigger.addEventListener("click", (e) => {
					const isOpen = e.currentTarget.parentElement.classList.contains("is-open");
					nav_has_children.forEach((drop) => drop.classList.remove("is-open"));

					if (!isOpen) {
						e.currentTarget.parentElement.classList.add("is-open");
					} else {
						e.currentTarget.parentElement.classList.remove("is-open");
					}
				});
			});
		});
	}

	/**
	 * SEARCHBAR
	 */
	let mini_searchbar = document.querySelector(".mini-searchbar");
	if (mini_searchbar) {
		let mini_searchbar_trigger = mini_searchbar.querySelector('[data-trigger="searchbar"]');
		const openSearchbar = (trigger) => {
			trigger.classList.toggle("is-active");
			document.body.classList.toggle("is-searchbar-open");
		};

		const closeSearchbar = () => {
			if (document.body.classList.contains("is-searchbar-open")) {
				document.body.classList.remove("is-searchbar-open");
			}

			if (mini_searchbar_trigger.classList.contains("is-active")) {
				mini_searchbar_trigger.classList.remove("is-active");
			}
		};

		// Close searchbar when clicked outside
		document.addEventListener(
			"mouseup",
			(e) => {
				if (!e.target.closest(".mini-searchbar")) {
					closeSearchbar();
				}
			},
			false
		);

		mini_searchbar_trigger.addEventListener("click", (e) => {
			e.preventDefault();
			openSearchbar(e.currentTarget);
		});
	}

	// Cards Slider
	let cards_sliders = document.querySelectorAll("section:not([data-horizontal-scroll]) .cards-slider");
	if (cards_sliders) {
		cards_sliders.forEach((slider) => {
			let swiper = slider.querySelector(".swiper");
			if (swiper) {
				let swiper_navigation = slider.querySelector(".cards-slider-navigation");

				Slider.initSwiper(swiper, {
					spaceBetween: 18,
					slidesPerView: 1.2,
					watchSlidesProgress: true,
					parallax: true,
					loop: true,
					loop: false,
					// mousewheel: {
					// 	releaseOnEdges: true,
					// },
					speed: 800,
					slidesOffsetAfter: document.getElementsByClassName("container")[0].getBoundingClientRect().left,
					navigation: {
						nextEl: swiper_navigation.querySelector(".swiper-button-next"),
					},
					breakpoints: {
						768: {
							spaceBetween: 40,
							slidesPerView: 1.6,
						},
						1281: {
							spaceBetween: 60,
							slidesPerView: 2.34,
						},
					},
				});
			}
		});
	}

	let pics_slider = document.querySelectorAll(".pics-slider");
	if (pics_slider) {
		pics_slider.forEach((slider) => {
			let swiper = slider.querySelector(".swiper");
			if (swiper) {
				let swiper_navigation = slider.querySelector(".pics-slider-navigation");

				Slider.initSwiper(swiper, {
					loop: true,
					slidesPerView: 1,
					parallax: true,
					speed: 800,
					navigation: {
						nextEl: swiper_navigation.querySelector(".swiper-button-next"),
					},
				});
			}
		});
	}

	// Bleed elements
	let $bleed_ctn = document.querySelectorAll("[data-bleed]");
	if (typeof $bleed_ctn != "undefined" && $bleed_ctn != null) {
		const offsetBleedBanner = () => {
			$bleed_ctn.forEach((banner) => {
				const $container = document.getElementsByClassName("container")[0];
				let offset = $container.getBoundingClientRect().left;
				banner.style.setProperty("--_bleed-x", `-${offset}px`);
			});
		};

		offsetBleedBanner();
		window.addEventListener("resize", offsetBleedBanner, false);
	}

	let boxes_slider = document.querySelectorAll(".boxes-slider");
	if (boxes_slider) {
		boxes_slider.forEach((slider) => {
			let swiper = slider.querySelector(".swiper");
			if (swiper) {
				let swiper_navigation = slider.querySelector(".boxes-slider-navigation");

				Slider.initSwiper(swiper, {
					slidesPerView: 1,
					parallax: true,
					speed: 800,
					navigation: {
						nextEl: swiper_navigation.querySelector(".swiper-button-next"),
						prevEl: swiper_navigation.querySelector(".swiper-button-prev"),
					},
					breakpoints: {
						768: {
							spaceBetween: 40,
							slidesPerView: 2,
						},
						1281: {
							slidesPerView: 3,
							spaceBetween: 60,
						},
					},
				});
			}
		});
	}

	let projects = document.querySelectorAll(".property-card");
	if (projects) {
		projects.forEach((project) => {
			let modalTarget = project.getAttribute("data-modal-trigger");
			let projectModal = document.querySelector(`[data-modal="${modalTarget}"]`);

			if (projectModal) {
				let jsTriggerPresentation = projectModal.querySelector(".js-trigger-presentation");
				let jsTriggerProgress = projectModal.querySelector(".js-trigger-progress");

				if (jsTriggerPresentation) {
					jsTriggerPresentation.addEventListener("click", (e) => {
						e.currentTarget.classList.add("is-active");
						if (jsTriggerProgress) jsTriggerProgress.classList.remove("is-active");
						projectModal.querySelector(`.modal__info-content`).classList.remove("d-none");
						projectModal.querySelector(`.modal__info-steps`).classList.add("d-none");
					});
				}

				if (jsTriggerProgress) {
					jsTriggerProgress.addEventListener("click", (e) => {
						e.currentTarget.classList.add("is-active");
						if (jsTriggerPresentation) jsTriggerPresentation.classList.remove("is-active");
						projectModal.querySelector(`.modal__info-content`).classList.add("d-none");
						projectModal.querySelector(`.modal__info-steps`).classList.remove("d-none");
					});
				}
			}
		});
	}

	// cms page
	let is_wpb = document.querySelector(".wpb-content-wrapper");
	if (is_wpb) {
		let scrollbar_width = window.innerWidth - document.documentElement.clientWidth;
		document.body.style.setProperty("--_scrollbar-w", `${scrollbar_width}px`);
	}

	// search page
	if (document.body.classList.contains("search")) {
		document.body.classList.add("header-is-stuck");
	}
});

window.addEventListener("resize", (e) => {
	bp_sm = window.matchMedia("(max-width: 768px)").matches;
	bp_md = window.matchMedia("(max-width: 1024px)").matches;
	bp_lg = window.matchMedia("(min-width: 1024px)").matches;
});
